import React from "react";

const backend = [
    {
        name: 'Canva',
    },
    {
        name: 'Figma',
    },
    {
        name: 'Adobe Photoshop',
    },
    {
        name: 'Adobe Premiere Pro',
    },
    {
        name: 'VN',
    }

]

const Graphic = () => {
    return (
        <div className='skills__content'>
            <h3 className='skills__title'>Graphic Design</h3>

            <div className="skills__box">
                {backend.map((item, index) => (
                    <div className="skills__data" key={index}>
                        <i className='bx bx-badge-check'></i>
                        <div>
                            <h3 className="skills__name">
                                {item.name}
                            </h3>
                            <span className="skills__level">
                                {item.level}
                            </span>
                        </div>
                    </div>

                ))}
            </div>
        </div>
    )
}

export default Graphic;
